/**
* 全局自定义指令
*/
import Vue from 'vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'



Vue.directive('transfer-dom', TransferDom)



// WEBPACK FOOTER //
// ./src/common/directives.js